import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import { CalendarIcon } from 'assets/icons';

const PLACEHOLDER = 'dd/mm/yyyy';

const styles = {
  field: ({ palette, breakpoints }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: 42,
    padding: '8px',
    backgroundColor: palette.colors.white,
    border: `1px solid ${palette.colors.lightGrey}`,
    borderRadius: '10px',
    cursor: 'pointer',
    [breakpoints.up('md')]: {
      minHeight: 56,
      gap: '16px',
      padding: '16px',
    },
  }),
  fieldError: ({ palette }) => ({
    borderColor: `${palette.primary.main} !important`,
  }),
  fieldDisabled: {
    cursor: 'default',
    opacity: 0.5,
  },
  fieldText: ({ typography, palette }) => ({
    ...typography.body2,
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: palette.text.primary,
  }),
  fieldPlaceholder: ({ palette }) => ({
    color: palette.colors.lightGrey,
  }),
  fieldIcon: ({ palette, breakpoints }) => ({
    width: 16,
    height: 16,
    flexShrink: 0,
    color: palette.primary.main,
    [breakpoints.up('md')]: {
      width: 24,
      height: 24,
    },
  }),
};

const setRef = (currentRef, node) => {
  if (!currentRef) {
    return;
  }

  if (typeof currentRef === 'function') {
    currentRef(node);
  } else {
    // eslint-disable-next-line no-param-reassign
    currentRef.current = node;
  }
};

export const DateTextField = (props) => {
  const {
    ref,
    id,
    displayValue = '',
    placeholder = '',
    error = false,
    disabled = false,
    setOpen = () => {},
    setAnchorEl = () => {},
    customStyles = {},
    inputRef,
    InputProps: { ref: anchorRef } = {},
  } = props;

  const handleRef = (node) => {
    setRef(ref, node);
    setRef(anchorRef, node);
    setRef(inputRef, node);
    setAnchorEl(node);
  };

  const handleClick = () => {
    if (!disabled) {
      setOpen((prev) => !prev);
    }
  };

  return (
    <Box
      ref={handleRef}
      id={id}
      sx={[styles.field, error && styles.fieldError, disabled && styles.fieldDisabled, customStyles.field]}
      onClick={handleClick}
    >
      <Typography sx={[styles.fieldText, !displayValue && styles.fieldPlaceholder, customStyles.text]}>
        {displayValue || placeholder || PLACEHOLDER}
      </Typography>
      <Box component={CalendarIcon} sx={styles.fieldIcon} />
    </Box>
  );
};

DateTextField.propTypes = {
  id: PropTypes.string,
  displayValue: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  setOpen: PropTypes.func,
  setAnchorEl: PropTypes.func,
  customStyles: PropTypes.shape({
    field: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    text: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  }),
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  InputProps: PropTypes.shape({
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  }),
};
